export default {
  messages: {
    en: {
      loadingError: `<p>We were unable to load this article. Please try again later.</p>`,
    },
  },
}
